<template>
    <DCard
        padding
    >
        <Form
            :countries="countries"
            :errors="errors"
            :tax-rule="taxRule"
            :tenant-languages="tenantLanguages"
            :default-tenant-language="defaultTenantLanguage"
            :effectiveness="effectiveness"
            :is-finance-system-netsuite="isFinanceSystemNetsuite"
            @form-submitted="submitData"
        />
    </DCard>
</template>

<script>
import Form from '~@/Components/Settings/TaxRules/Form'

export default {
    name: 'TaxRuleUpdate',
    components: {
        Form
    },
    props: {
        countries: {
            type: Array,
            default: () => { return [] }
        },
        errors: {
            type: Object,
            default: () => { return {} }
        },
        taxRule: {
            type: Object,
            default: () => { return {} }
        },
        defaultTenantLanguage: {
            type: String,
            default: ''
        },
        tenantLanguages: {
            type: Array,
            default: () => []
        },
        effectiveness: {
            type: Array,
            default: () => []
        },
        isFinanceSystemNetsuite: {
            type: Boolean,
            default: () => { return false }
        }
    },
    methods: {
        submitData (form) {
            form.put(this.$route('settings.tax-rules.update', this.taxRule.id))
        }
    }
}
</script>
